import React from "react";
import ProjectCard from "./ProjectCard";
import projects from "./Project.json";
import "./Projects.scss";

function Projects() {
  return (
    <div className="projects section-shell">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Current portfolio</span>
          <h2>Systems worth leading with</h2>
        </div>
        <p>
          A tighter selection of production work and recent builds: platforms, agent workflows, validation systems, and
          reliability-first products.
        </p>
      </div>

      <div className="projects__grid">
        {projects.map((project, index) => (
          <ProjectCard key={project.id} project={project} index={index} />
        ))}
      </div>
    </div>
  );
}

export default Projects;
